module.exports = __webpack_public_path__ + "static/media/fedpa-star.ef6009d0.svg";